import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M320.224,1705.45 L1386.89,1707.88 L1386.65,1814.55 L319.981,1812.12 L320.224,1705.45 Z M320.203,1492.12 L1600.2,1494.55 L1600,1601.22 L320.001,1598.78 L320.203,1492.12 Z M1866.67,320 C1896.12,320 1920,343.878 1920,373.334 L1920,1333.33 C1920,1362.79 1896.12,1386.67 1866.67,1386.67 L53.3334,1386.67 C23.8782,1386.67 0,1362.79 0,1333.33 L0,373.334 C0,343.878 23.8781,320 53.3333,320 L1866.67,320 Z M1653.33,586.667 L266.667,586.667 C237.50556,586.667 213.811118,610.069828 213.333,639.118041 L213.333,640 L213.333,853.334 C213.333,882.49445 236.735828,906.188882 265.785012,906.659855 L266.667,906.667 L1653.33,906.667 C1682.4954,906.667 1706.19184,883.264172 1706.67,854.215959 L1706.67,853.334 L1706.67,640 C1706.67,610.83955 1683.26521,587.145118 1654.21211,586.674145 L1653.33,586.667 Z M320.203,105.451 L1600.2,107.883 L1600,214.549 L320.001,212.118 L320.203,105.451 Z",
  fillRule: "nonzero",
  stroke: "none",
  strokeWidth: "1"
});

var IconLineReaderSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconLineReaderSolid, _Component);

  var _super = _createSuper(IconLineReaderSolid);

  function IconLineReaderSolid() {
    _classCallCheck(this, IconLineReaderSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconLineReaderSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconLineReader",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconLineReaderSolid.displayName = "IconLineReaderSolid";
  return IconLineReaderSolid;
}(Component);

IconLineReaderSolid.glyphName = 'line-reader';
IconLineReaderSolid.variant = 'Solid';
IconLineReaderSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconLineReaderSolid;
export { IconLineReaderSolid };